import i18next from "i18next";
import { IQuantity, Quantity } from "../../../../common/models/quantity.model";

export const generateDetailedPrice = (quantity: IQuantity, actions: any, isLoading: boolean, selectedValidator?: any) => {
  const t = i18next.getFixedT(null, "admin");
  const item = [
    {
      key: "download",
      text: t("nav.download"),
      iconProps: { iconName: "Download" },
      onClick: actions.exportFile,
      disabled: isLoading,
    },
  ];

  switch (quantity) {
    case Quantity.NONE:
      return [...item];
    case Quantity.ONE:
      return [...item];
    case Quantity.MANY:
      return [...item];
  }
};